import { FC } from 'react';
import { useIntl } from 'react-intl';
import { useEventGeneratorClickCta } from 'src/analytics/useEventGeneratorClickCta';
import { Button } from 'src/components';
import { useCtaHref } from 'src/hooks/useCtaHref';
import { YoutubeScenario } from 'src/types/domain';
import { useTargetMessages } from 'src/hooks/useTargetMessages';
import Learnables from '../../Learnables';
import Card from '../Card';
import * as msgsData from './messages';
import * as S from './styles';

const { msgs, ...localesWithMessages } = msgsData;

const PALETTE = 'purple';

type LearnImmerseProps = {
  scenario: YoutubeScenario;
};

const LearnImmerse: FC<LearnImmerseProps> = ({ scenario: { learnables, mediaMetadata } }) => {
  const intl = useIntl();
  const targetMsgs = useTargetMessages(localesWithMessages);

  const cta = intl.formatMessage(msgs.cta);
  const learnablesLabel = intl.formatMessage(msgs.learnablesLabel);
  const text = intl.formatMessage(targetMsgs.text);
  const title = intl.formatMessage(targetMsgs.title);
  const topic = intl.formatMessage(msgs.topic);

  const signUpHref = useCtaHref();
  const eventGeneratorClickCta = useEventGeneratorClickCta();

  return (
    <Card $palette={PALETTE}>
      <S.Topic $palette={PALETTE}>{topic}</S.Topic>
      <S.Title>{title}</S.Title>
      <S.Text>{text}</S.Text>
      <S.YoutubeIframe url={mediaMetadata.youtube.url} />

      <S.FixFlexBasis>
        <Button
          analyticsEvent={eventGeneratorClickCta}
          buttonSizeBreakpoint="md"
          buttonType="primary"
          fullWidth="always"
          href={signUpHref}
        >
          {cta}
        </Button>
      </S.FixFlexBasis>

      <S.LearnablesLabel>{learnablesLabel}</S.LearnablesLabel>
      <Learnables learnables={learnables} $palette={PALETTE} />
    </Card>
  );
};

export default LearnImmerse;
